import { LoadablePaint } from '@confluence/loadable';

export const Nav4Layout = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Nav4-layout" */ './PageLayout')).PageLayout,
});
